export type PageTransitionDirection = "left" | "right";

export interface PageTransitionDetail {
  direction: PageTransitionDirection;
  nonce: number;
}

export const PAGE_TRANSITION_DURATION_MS = 480;
export const PAGE_TRANSITION_EVENT = "app:page-transition";

export const triggerPageTransition = (direction: PageTransitionDirection) => {
  window.dispatchEvent(
    new CustomEvent<PageTransitionDetail>(PAGE_TRANSITION_EVENT, {
      detail: {
        direction,
        nonce: Date.now(),
      },
    })
  );
};

export const navigateWithPageTransition = (
  navigate: (to: string) => void,
  to: string,
  direction: PageTransitionDirection
) => {
  triggerPageTransition(direction);
  window.requestAnimationFrame(() => {
    navigate(to);
  });
  return window.setTimeout(() => undefined, 0);
};
